<template>
  <v-row class="fill-height">
    <v-col>
      <v-sheet height="64">
        <v-toolbar
          flat
          color="white"
        >
          <v-btn
            fab
            text
            small
            @click="prev"
          >
            <v-icon small>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-btn
            fab
            text
            small
            @click="next"
          >
            <v-icon small>
              mdi-chevron-right
            </v-icon>
          </v-btn>
          <v-toolbar-title>{{ title }}</v-toolbar-title>
          <v-spacer />
          <v-menu
            bottom
            right
          >
            <template v-slot:activator="{ on }" />
          </v-menu>
        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="primary"
          :events="events"
          event-name="title"
          event-details="description"
          event-start="start_date"
          event-end="end_date"
          :event-margin-bottom="3"
          :now="today"
          :type="type"
          @click:event="showEvent"
          @click:day="showAddEventForm"
          @click:date="showAddEventForm"
          @change="updateRange"
        />
        <AddEventForm
          ref="addEvent"
          :action="action"
        />
      </v-sheet>
    </v-col>
  </v-row>
</template>

<style scoped>
@media (min-width: 360px) and (max-width: 767px) {
  .ma-2 {
    margin: 2% !important;
    width: 97.5%;
  }
}
</style>

<script>
import { mapState, mapActions } from "vuex";
import AddEventForm from "./AddEventForm";

export default {
  components: {
    AddEventForm
  },
  data: () => ({
    action: null,
    start: null,
    end: null,
    today: new Date().toISOString().slice(0, 10), // it's this for moment ok :^)
    focus: new Date().toISOString().slice(0, 10),
    type: "month"
  }),
  computed: {
    ...mapState("calendar", ["events"]),
    title() {
      const { start, end } = this;
      if (!start || !end) {
        return "";
      }

      const startMonth = this.monthFormatter(start);
      const startYear = start.year;

      return `${startMonth} ${startYear}`;
    },
    monthFormatter() {
      return this.$refs.calendar.getFormatter({
        timeZone: "UTC",
        month: "long"
      });
    }
  },
  mounted() {
    this.checkChange();
  },
  created() {
    this.getProjects();
    this.fetchEvents();
  },
  methods: {
    ...mapActions("calendar", ["fetchEvents"]),
    ...mapActions("projects", ["getProjects"]),
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showAddEventForm({ date }) {
      this.action = "add";
      this.$refs.addEvent.showAddEventForm(date);
    },
    showEditForm({ event }) {
      this.action = "edit";
      this.$refs.addEvent.showEditForm(event);
    },
    showEvent({ nativeEvent, event }) {
      this.action = "edit";
      this.$refs.addEvent.showEditForm(event);
      nativeEvent.stopPropagation(); // this is required to suppress @click:day from being triggered when clicking on an event
    },
    updateRange({ start, end }) {
      this.start = start;
      this.end = end;
    },
    checkChange() {
      this.$refs.calendar.checkChange();
    }
  }
};
</script>
